import transformation from 'modules/projectBrowser/transformation';

const getProjectDetails = state => {
  const projectDetails = state.projectBrowser.projectDetails;
  if (!projectDetails || projectDetails.length === 0) {
    return null;
  }
  return state.projectBrowser.projectDetails;
};

const getProjectDetailsLoading = state => {
  return state.projectBrowser.loading.projectDetailsLoading;
};

const getProjectDetailsError = state => {
  return state.projectBrowser.error.projectDetailsError;
};

// For a Particular Selected Product

const getParticularProductDetails = state => {
  return state.projectBrowser.particularProductDetail;
};

const getParticularProjectDetailsLoading = state => {
  return state.projectBrowser.loading.particularProductDetailLoading;
};

const getParticularProductDetailsError = state => {
  return state.projectBrowser.error.particularProductDetailError;
};

const getRecommendedProject = state => {
  return transformation.transformRecommendedProjects(state);
};

const getAllPropertiesRecommended = state => {
  return transformation.transformAllPropertiesRecommended(state);
};

const isLoading = state => {
  return (
    getProjectDetailsLoading(state) || getParticularProjectDetailsLoading(state)
  );
};

export const ProjectBrowserSelector = {
  isLoading,
  getProjectDetails,
  getProjectDetailsLoading,
  getProjectDetailsError,
  getParticularProductDetails,
  getParticularProductDetailsError,
  getParticularProjectDetailsLoading,
  getRecommendedProject,
  getAllPropertiesRecommended,
};
